// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LogoTitle_wrapper__j2UFp","name":"LogoTitle_name__2QSPT","logo":"LogoTitle_logo__16Ugk"};